export default __webpack_public_path__ + "static/media/image.cyber-warders.10251c73.png";